import { render, staticRenderFns } from "./new-cart-complete.vue?vue&type=template&id=2a87789c&scoped=true&"
import script from "./new-cart-complete.vue?vue&type=script&lang=js&"
export * from "./new-cart-complete.vue?vue&type=script&lang=js&"
import style0 from "./new-cart-complete.vue?vue&type=style&index=0&id=2a87789c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a87789c",
  null
  
)

export default component.exports